<template lang="pug">
#tweet.center( v-bind:style="{width: width || '300px', maxHeight: height || '700px' }")
  .relative(:id="t._id")
    .controls(v-if="!noControls")
      .col.s5
        p.smallSize.center(@click="fav('love')" style="color:#00ffff" v-bind:class="{active:t.fav=='love'}") LOVE
      .col.s2
        p.smallSize.center(style="opacity:0.7" @click="unlike()") X
      .col.s5
        p.smallSize.center(@click="fav('hate')" style="color:#ff00ff" v-bind:class="{active:t.fav=='hate'}") HATE
</template>

<script>
var baseUrl = window.location.hostname == "localhost" ? "http://localhost:5500" : "";

export default {
  props: ["t", "width", "height", "noControls"],
  mounted(){
    twttr.widgets.createTweet(
      this.t._id,
      document.getElementById(this.t._id),
      {
        align: 'center'
      })
      .then(function (el) {
        //console.log(el)
      }).catch(console.error);
  },
  methods:{
    fav(loveorhate){
      this.t.fav = loveorhate;
      axios.get(baseUrl + "/projects/likeTweet/" + this.t._id + "/" + loveorhate).then(({data})=>{

      });
    }
  }
}
</script>

<style lang="sass" scoped>
#tweet
  position: relative
  //background-color: #FFF
  color: #ccc
  margin: 0 5px
  .controls
    position: absolute
    width: 80%
    top: 0
    left: 50%
    transform: translate(-50%, 50%)
    background-color: #333
    opacity: 0
    transition: opacity 0.5s
  &:hover .controls
    opacity: 1
  .active
    border: 2px solid #666

</style>



// WEBPACK FOOTER //
// src/components/tweet.vue